export type TrainingModuleModel = {
  cache_key: number,
  data: any,
  id: number,
  lesson_count?: number,
  title: string,
  training_course_id: number,
}

export type TrainingModuleRequestOptions = {}

const state = {
  data: {},
  id: null,
  lesson_count: null,
  title: '',
  training_course_id: undefined,
}

export const requiredFields = [
  { key: 'title' },
  { key: 'training_course_id' },
]

export default state
